// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1N5Rt","list":"BalanceDue_list__2dd2r","listRow":"BalanceDue_listRow__2kW6N","total":"BalanceDue_total__CYClu"};